// When to check again while today is on screen, as on the phone (RefreshPolicy.kt).
//
// CGM readings land every 5 minutes, so a fresh day waits until the next one is due. When the
// feed falls behind, the uploader backfills missed readings with their original timestamps
// once it resumes; those don't change the newest reading, so a stale day is polled every
// minute until it catches up.

export const READING_INTERVAL_MS = 5 * 60_000;
export const GRACE_MS = 30_000;
export const STALE_POLL_MS = 60_000;
const MIN_DELAY_MS = 15_000;

export function nextDelayMs(latestReadingMs: number | null, nowMs: number): number {
  if (latestReadingMs === null) return STALE_POLL_MS;
  const age = nowMs - latestReadingMs;
  if (age >= READING_INTERVAL_MS) return STALE_POLL_MS;
  return Math.min(READING_INTERVAL_MS + GRACE_MS, Math.max(MIN_DELAY_MS, READING_INTERVAL_MS + GRACE_MS - age));
}
